module.exports = __webpack_public_path__ + "img/usecase2.16f0fb1.svg";